import { parseQuery } from '@calendly/http-tools'

export const showTimezonePopupSelector = ({ timezone }) => {
  const { source, timezone_picker: showTimezonePicker } = parseQuery(window.location.search)
  return source === 'email'
    && !showTimezonePicker
    && !timezone.selected
    && timezone.fromQuery
    && timezone.detected !== timezone.fromQuery
}
